export default "__VITE_ASSET__2WXNXRTK__"